import emailjs from "@emailjs/browser";
import { useRef } from "react";

export function ContactUs() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ctxtdip", // EmailJS Service ID
        "template_p2le25h", // EmailJS Template ID
        form.current,
        "hYGuDjIbCMDAGPBPn", // EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message sent! We’ll get back to you soon 🤘");
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          alert("Something went wrong. Try again.");
        },
      );
  };

  return (
    <section id="contact" className="contact">
      <h2>Contact Us</h2>
      <p>cascadeyvr@gmail.com</p>

      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <input type="text" name="from_name" placeholder="Your Name" required />
        <input type="email" name="reply_to" placeholder="Your Email" required />
        <textarea
          name="subject"
          placeholder="Subject"
          rows="1"
          required
        ></textarea>
        <textarea
          name="message"
          placeholder="Your Message"
          rows="5"
          required
        ></textarea>
        <button type="submit">Send</button>
      </form>
    </section>
  );
}
